import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Session from './auth/Session';

/**
 * AdminRoute
 * Wraps a React Router <Route> and redirects to /login if the user
 * does not have the Admin or CSR role.
 *
 * Usage:
 *   <AdminRoute path="/data/dashboard" component={QuoteDashboard} />
 */
export function AdminRoute({ component: Component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) => {
                const token = Session.getToken();
                if (!token) {
                    return (
                        <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                    );
                }

                const roles = Session.getRole() || [];
                const hasAccess = roles.includes('Admin');

                if (!hasAccess) {
                    return <Redirect to="/" />;
                }

                return <Component {...props} />;
            }}
        />
    );
}